import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getNotificationListsSuccess,
  getNotificationListsFailed,
  GET_LIST_NOTIFICATION_START,
} from '../../actions/notification'
import { api } from '~/services/api'
import {
  GET_HISTORIES_HASH_CHIP_POOL_START,
  getHistoriesHashChipPoolFailed,
  getHistoriesHashChipPoolSuccess
} from "~/views/app/redux/actions/pools";

/**
 * get list notification api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getHashChipRedeemedHistoriesApi = (props) => {
  return api.get(`/admin/hash-chip-redeemed/histories`, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetHashChipRedeemedHistories(action) {
  try {
    const response = yield call(getHashChipRedeemedHistoriesApi, action?.payload)
    yield put(getHistoriesHashChipPoolSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getHistoriesHashChipPoolFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list notification
 */
export default function* watchGetHashChipRedeemedHistories() {
  yield takeLatest(GET_HISTORIES_HASH_CHIP_POOL_START, doGetHashChipRedeemedHistories)
}
